import {
    CAR_DATA_MASTER_GET_EXCEL_PRICES_BEGIN,
    CAR_DATA_MASTER_GET_EXCEL_PRICES_SUCCESS,
    CAR_DATA_MASTER_GET_EXCEL_PRICES_FAILURE
  } from './constants';

import { BFFAgent } from 'BFFAgent';
  
  export function getExcelPrices(isClassicView) {
    return async dispatch =>{
        dispatch({
            type:CAR_DATA_MASTER_GET_EXCEL_PRICES_BEGIN,
        })
        try {
            await BFFAgent.Datamasters.getExcelPrices(isClassicView)
            dispatch({
                type:CAR_DATA_MASTER_GET_EXCEL_PRICES_SUCCESS
            })
        } catch (error) {
            dispatch({
                type:CAR_DATA_MASTER_GET_EXCEL_PRICES_FAILURE,
            })
        }
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case CAR_DATA_MASTER_GET_EXCEL_PRICES_BEGIN:
        return {
          ...state,
          loadingExcelPrices:true
        };
      case CAR_DATA_MASTER_GET_EXCEL_PRICES_SUCCESS:
        return{
            ...state,
            loadingExcelPrices:false
        }
      case CAR_DATA_MASTER_GET_EXCEL_PRICES_FAILURE:
        return{
            ...state,
            loadingExcelPrices:false,
            errorExcelPrices:true
        }
  
      default:
        return state;
    }
  }
  